module.exports = __webpack_public_path__ + "img/ios-iphone-bottom-chin.f35e3fd1.png";